import { ErrorSidePanel } from '@/components/errors';
import { loadHistoryState } from '@/lib';
import { ErrorCodes, templates, type SkinPageConfig } from '@nosinovacao/nosid-mfe-common';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { inviteSuccessStateSchema } from '../-model/flow';
import { type InviteSuccessProps } from './-model/props';
import { InviteSuccessLight } from './-skins';

export const Route = createFileRoute('/(services)/services/_sheet/users/invite-success/')({
  loader: loadHistoryState(inviteSuccessStateSchema, { errorCode: ErrorCodes.AccessDenied }),
  component: RouteComponent,
  errorComponent: ErrorSidePanel,
});

function RouteComponent() {
  const { email, userId } = Route.useLoaderData();
  const navigate = useNavigate();

  function handleManageAccess() {
    navigate({ to: '/services/users/$userId', params: { userId } });
  }

  const props: InviteSuccessProps = {
    email,
    onManageAccess: handleManageAccess,
  };
  return templates.getSkinSelector(skinConfig(props));
}

function skinConfig(props: InviteSuccessProps): SkinPageConfig {
  return {
    skins: [],
    defaultValue: <InviteSuccessLight {...props} />,
  };
}
